import { render } from "./NewsSearchParams.vue?vue&type=template&id=a85c406c"
import script from "./NewsSearchParams.vue?vue&type=script&lang=ts"
export * from "./NewsSearchParams.vue?vue&type=script&lang=ts"
script.render = render

export default script